import { isEmpty } from 'lodash-es';
import { useCallback, useMemo } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { Button, Stack } from 'src/core/ui';
import { PillList } from 'src/core/ui/PillList';
import { PillItemProps } from 'src/core/ui/PillList/PillItem';
import { ContentId } from 'src/utils/constants/contentId';
import { SectionInfo } from 'src/WebApiController';

import * as styles from './OnSaleEventDetails.css';
import { OnSaleEventDetailsHeader } from './OnSaleEventDetailsHeader';

export const OnSaleEventSectionSelection = ({
  selectedSections,
  onSelectedSectionsChange,
}: {
  selectedSections?: SectionInfo[];
  onSelectedSectionsChange: (sections: SectionInfo[]) => void;
}) => {
  const selectedSectionPills = useMemo((): PillItemProps[] => {
    return (selectedSections ?? []).map((section) => {
      return {
        value: section.id + '',
        display: section.name,
      };
    });
  }, [selectedSections]);

  const onSectionDelete = useCallback(
    (sectionId: string) => {
      const updatedSections = (selectedSections ?? []).filter(
        ({ id }) => id + '' !== sectionId
      );
      onSelectedSectionsChange(updatedSections);
    },
    [onSelectedSectionsChange, selectedSections]
  );

  if (isEmpty(selectedSectionPills)) {
    return null;
  }

  return (
    <Stack direction="column" width="full">
      <OnSaleEventDetailsHeader titleContentId={ContentId.SelectedSections} />
      <Stack width="full" direction="row" gap="m">
        <div style={{ overflow: 'auto', flex: 1 }}>
          <PillList
            pills={selectedSectionPills}
            scrollButtonClassName={styles.pillItemsScrollButton}
            condensed
            onPillDeleted={onSectionDelete}
          />
        </div>
        <Button variant="link" onClick={() => onSelectedSectionsChange([])}>
          <Content id={ContentId.ClearAll} />
        </Button>
      </Stack>
    </Stack>
  );
};
